import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { isAfisCyprus } from 'shared-pages/common/constants';
import i18next from 'i18next';

const gqlGetValues = gql`
  query getGpsUpdateTypesView($where: String, $offset: Int, $limit: Int, $order: String) {
    getGpsUpdateTypesView(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id: id
        description: name
      }
      recordCount
    }
  }
`;

// export function useGetRegionAsOptionsQuery() {
//   return useLazyQuery(gqlGetValues, {
//     fetchPolicy: 'cache-first',
//   });
// }

function useGetRegionLazyQuery() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

// interface LcFsProps extends FsProps {
//   size?: 'sm' | 'lg';
// }

export const FieldSelectGpsUpdateType = ({
  label = i18next.t('Ενημέρωση θέσης'),
  name = 'gpsUpdateId',
  defaultValues = {},
  // size = 'sm',
  ...rest
}: FsProps) => {
  //const where = JSON.stringify({ isActive: true });
  return (
    <FieldSelectDB
      // height={size === 'lg' ? 32 : '22'}
      {...rest}
      label={label}
      name={name}
      sbLabel={(defaultValues as any)?.region?.name ?? undefined}
      //where={where}
      hook={useGetRegionLazyQuery}
    />
  );
};

